import { render, staticRenderFns } from "./AddUpdateMenu.vue?vue&type=template&id=f3829302&scoped=true"
import script from "./AddUpdateMenu.vue?vue&type=script&lang=js"
export * from "./AddUpdateMenu.vue?vue&type=script&lang=js"
import style0 from "./AddUpdateMenu.vue?vue&type=style&index=0&id=f3829302&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3829302",
  null
  
)

export default component.exports